<template>
  <div class="video-select">
    <a-list v-if="selectMaterials.length>0" :grid="{ gutter: 16, column: 3 }" :data-source="selectMaterials">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card :title="item.videoName">
          <a-row type="flex">
            <a-col :flex="1">
              <video controls style="width:100px" :src="item.url"  ref="video"/>
              <br> 
              <a-button :icon="'delete'" @click="deleteMaterial(item)">
                删除
              </a-button>
            </a-col>
            <a-col :flex="3">
              <img style="width:100px" :src="item.thumbnail? item.thumbnail : item.cover" /><br>
              <a-tag color="green" class="video_select_tag">封面</a-tag>
            </a-col>
          </a-row>
        </a-card>
      </a-list-item>
    </a-list>

    <a-space size="large" style="margin-top: 15px;">
      <a-button class="upload"  type="dashed" :icon="'select'" @click="buttonClick" v-if="num > selectMaterials.length">
        <b v-if="selectMaterials.length>0"> 已选择 {{selectMaterials.length}}/{{ num }} 个视频 </b>
        <b v-else> 点击添加素材 </b>
      </a-button>

      <a-button class="upload"  type="dashed" :icon="'select'" v-else>
        <b> 已选择 {{selectMaterials.length}}/{{ num }} 个视频 </b>
      </a-button>

      <a-button type="danger" v-if="selectMaterials.length>0" @click="clearSelectMaterials()" >
        清除所有选中视频
      </a-button>
    </a-space>


    <a-modal 
      centered
      :title="`选择视频素材`"
      :width="'70%'"
      :mask-closable="false"
      :visible="showVideoPage"
      :bodyStyle="{ padding: 0 }"
      @cancel="close"
      okText="选择视频"
      @ok="choiceMaterialBatch"
    >
        <div style="min-height:600px;margin:10px">
              <div class="search-wrapper" ref="search">
                  <a-space>
                    <a-range-picker v-model="queryParam.date" />
                    <a-input allow-clear placeholder="视频ID" v-model="queryParam.ids" />
                    <a-input allow-clear placeholder="名称" v-model="queryParam.videoName" />
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button @click="resetSearch">重置</a-button>
                  </a-space>
              </div>

              <a-table
                  :scroll="{ x: 500, y:430}"
                  :columns="columns"
                  :row-key="record => record.videoid"
                  :data-source="data"
                  :pagination="pagination"
                  
                  :row-selection="{ onChange: onSelectChange, selectedRowKeys: selectedRowKeys }"
                  :loading="loading"
                  :transform-cell-text="$helper.emptyFormat"
                  @change="handleTableChange"
              >

              <div slot="video" slot-scope="video" >
                <div class="cover"  @mouseenter="showPreviewBox(video)" @mouseleave="hidePreviewBox(video)">
                  <div>
                    <video v-if="playUrl !== null && material && material.videoid === video.videoid" autoplay rel="noreferrer" :src="playUrl" ref="video"/>
                    <img v-else :src="video.thumbnail || defaultCover" @error="imgError">
                  </div>
                </div>
              </div>

              <div slot="name" slot-scope="material" class="detail">
                <div class="name">
                    {{ material.videoName }}
                </div>
                <div>
                    <span> 素材尺寸：{{ material.width }} * {{ material.height }} </span>
                </div>
                <div>
                    <span> 素材大小：{{ material.capacity }}M </span>
                </div>
                <div>
                    <span> 素材格式：{{ material.format }} </span>
                </div>
                <div>
                    <span> 时长：{{ material.duration }}秒</span>
                </div>
                <div class="words"></div>
                <div class="info">
                    <p></p>
                </div>
            </div>

            <div slot="action" slot-scope="record" class="actions">
              <a href="javascript:;" @click="choiceMaterialSingle(record)">选择</a>  
            </div>

              </a-table>
        </div>
    </a-modal>
    
  </div>
</template>

<style lang="less" scoped>
@import 'VideoSelect';
</style>

<script>
import VideoSelect from './VideoSelect'
export default VideoSelect
</script>

